export const SUPPORT_REQUEST_TYPE_IDS = {
  TECH_SUPPORT_REQUEST_ID: 1,
  LIBRARY_FIXTURE_REQUEST_ID: 2,
};

// unused
//export const SUPPORT_DEPARTMENT_IDS = {
//   WYSIWYG_SUPPORT_ID: 1,
//   VIVIEN_SUPPORT_ID: 2,
// };

export const SUPPORT_REQUEST_CATEGORY_IDS = {
  GENERAL_CATEGORY_ID: 1,
  DEFECTS_CATEGORY_ID: 2,
  ENQUIRY_CATEGORY_ID: 3,
  FEATURE_REQUEST_CATEGORY_ID: 4,
  SALES_CATEGORY_ID: 5,
  OTHER_CATEGORY_ID: 6,
  AUTHENTICATION_CODE_CATEGORY_ID: 7,
  CREDENTIALS_CATEGORY_ID: 8,
  FILE_IMPORT_EXPORT_CATEGORY_ID: 9,
  HARDWARE_CATEGORY_ID: 10,
  HOW_TO_CATEGORY_ID: 11,
  INSTALLATION_CATEGORY_ID: 12,
  LICENSE_MEMBERSHIP_CATEGORY_ID: 13,
  OPERATIONAL_ERROR_CATEGORY_ID: 14,
  PERFORMANCE_CATEGORY_ID: 15,
  STARTUP_CATEGORY_ID: 16,
  VISUALIZATION_CATEGORY_ID: 17,
  WEBSITE_CATEGORY_ID: 18,
  PROCESSING_HWID_CATEGORY_ID: 19,
  TESTING_BETA_FEATURE_CATEGORY_ID: 20,
};

export const SUPPORT_REQUEST_SUBCATEGORY_IDS = {
  CONSOLE_SUBCATEGORY_ID: 1,
  DONGLE_SUBCATEGORY_ID: 2,
  DONGLE_OWNERSHIP_CHANGE_SUBCATEGORY_ID: 3,
  CLOUD_ENTITLEMENT_CHANGE_SUBCATEGORY_ID: 4,
  FILE_OPERATIONS_SUBCATEGORY_ID: 5,
  HARDWARE_SUBCATEGORY_ID: 6,
  IMPORT_MERGE_SUBCATEGORY_ID: 7,
  EXPORT_SUBCATEGORY_ID: 8,
  PRE_SALES_DEMO_SUBCATEGORY_ID: 9,
  INFO_HOW_TO_SUBCATEGORY_ID: 10,
  INSTALLATION_SUBCATEGORY_ID: 11,
  LIBRARY_ISSUE_SUBCATEGORY_ID: 12,
  LIBRARY_REQUEST_SUBCATEGORY_ID: 13,
  LEASE_SUBCATEGORY_ID: 14,
  MEMBERSHIP_SUBCATEGORY_ID: 15,
  MEMBERSHIP_RENEWAL_SUBCATEGORY_ID: 16,
  PASSWORD_SUBCATEGORY_ID: 17,
  PERFORMANCE_SUBCATEGORY_ID: 18,
  PRINT_SUBCATEGORY_ID: 19,
  RE_AUTHORIZATION_SUBCATEGORY_ID: 20,
  REGISTRATION_SUBCATEGORY_ID: 21,
  RENDER_SUBCATEGORY_ID: 22,
  SHADED_VIEW_STARTUP_SUBCATEGORY_ID: 23,
  SUGGESTION_SUBCATEGORY_ID: 24,
  UPGRADE_SUBCATEGORY_ID: 25,
  WEBSITE_MOA_ERROR_SUBCATEGORY_ID: 26,
};
